<template>
    <div class="widget-calendar">
        <dashboardCard heading='Data Repository Invocation' :data1="dataInvocationCount" :data2="dataInvocationMax"
            :data3="dataInvocationTime">
        </dashboardCard>
    </div>
</template>
<script>
import dashboardCard from "./DashboardCard.vue";
export default {
    name: "dataRepoDetail",
    components: {
        dashboardCard
    },
    data() {
        return {
            dataInvocationCount: {},
            dataInvocationMax: {},
            dataInvocationTime: {},
        };
    },
    methods: {
        getDataInvocationInfo(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    this.dataInvocationCount.value = this.formatValue(response.server.data[0].value.toFixed(3));
                    this.dataInvocationCount.name = 'Count';
                    this.dataInvocationMax.value = this.formatTime((response.server.data[1].value).toFixed(3));
                    this.dataInvocationMax.name = 'Max';
                    this.dataInvocationTime.value = this.formatTime((response.server.data[2].value).toFixed(3));
                    this.dataInvocationTime.name = 'Total Time';
                    this.dataInvocationCount.description = 'Total number of times repository methods have been called.';
                    this.dataInvocationMax.description = 'Maximum time taken by a single repository method invocation.';
                    this.dataInvocationTime.description = 'Total execution time of all repository method calls combined.';
                })
                .catch(error => {
                    console.log(error);
                });
        },
        formatValue(value) {
            return value > 100 ? (value / 1000).toFixed(2) + 'k' : value;
        },
        formatTime(seconds) {
            if (seconds < 60) {
                return `${seconds}s`;
            } else if (seconds < 3600) {
                const minutes = Math.floor(seconds / 60);
                return `${minutes}m`;
            } else {
                const hours = Math.floor(seconds / 3600);
                const minutes = Math.floor((seconds % 3600) / 60);
                const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
                return `${hours}h ${formattedMinutes}m`;
            }
        },
    },
    mounted() {
        this.getDataInvocationInfo("DATA_INVOCATION");
    }
};
</script>